















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { newCheck,newCheckOperation } from '@/api/task/team';
import { getFromType } from '@/api/task/crowd';
import { detail as taskDetail,partnerBatchDownload,getQiniuToken,partnerBatchCheck,newCheckId,partnerDownloadAll } from '@/api/task/common';
import { detail as judgeDetail } from '@/api/task/judge';
import { DOMAIN, JIDU_DOMAIN } from '@/global/constants';
import * as qiniu from 'qiniu-js';
import { uploadOss } from '@/global/utils'
@Component
export default class Check extends Vue {
  private dataList: object[] = [];
  private inspectSelection = [];
  //批量提交弹窗
  private partnerShow :boolean = false;
  private partnerEmail :boolean = false;
  private percent:number = 101;
  private total: number | string = 0;
  private currentUid: number | string = 0;
    //批量上传csv-url
  private partnerCSVUrl:string='';
  private dataListNoSelectTags: object[] = [];
  private selectedIds= new Set;
  private resultIds= new Set;
  private importAll:boolean=false;
  private selectedSum:number = 0; //选中的总数量
  private task: object = {};
  private searchParams: object = {
    mid: '',
    lid: '',
    puid: '',
    pteamid: '',
    audit_status: '-1',
    page: '1',
    pagesize: '20',
  };
  private formData: object = {
      email: ''
  };
  private ruleValidate = {
            email: [{ required: true, message: '邮箱地址不能为空', trigger: 'blur' }]
        };
  private columnsSchema: object[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '题目ID',
      key: 'id',
      align: 'center',
    },
    {
      title: '题ID',
      key: 'lid',
      align: 'center',
    },
    {
      title: '题包ID',
      key: 'pkg_id',
      align: 'center',
    },
    {
      title:'Benchmark',
      slot:'benchmark',
      align:'center',
      width: 200,
    },
    {
      title: '提交时间',
      slot: 'time',
      align: 'center',
    },
    {
      title: '当前状态',
      key: 'checkStatusString',
      align: 'center',
    },
    {
      title: '查看详情',
      slot: 'show',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'operate',
      align: 'center',
    },
  ];
  @Watch('$route')
  private routechange(to: any, from: any) {
    if (to.name == 'examineDetail') {
      this.handleReset()
      this.getTask(); // 重新加载数据
    }
  }
  private created() {
    this.getTask();
  }
  private activated(){
    this.getTask();
  }

  private async getTask() {
    this.currentUid = this.$store.state.userInfo.id
    this.task = this.$store.state.task;
    if (!(this.task && (this.task as any).id)) {
      const page = this.$route.params.page;
      const params = { id: this.$route.params.id };
      let resp: any;
      if (page == 'judge') {
        resp = await judgeDetail(params);
      } else {
        resp = await taskDetail(params);
      }
      this.$nextTick(() => {
        this.task = resp.result;
        this.$store.commit('setTask', resp.dta);
        this.getList();
      });
    } else {
      this.getList();
    }
  }

  public selectChange(selection) {
    this.inspectSelection = selection;
  }

  public handlerSelectAll(status){
    console.log(status);
    if(!this.$refs.selection || !(this.$refs.selection as any).data ){
      return null;
    }
    this.importAll=status;
    (this.$refs.selection as any).selectAll(status)
    // this.$refs.selection.selectAll(status);
    // this.selectNums=this.total;

  }
  //全选取消全选当前页
  public handleSelectAll(selection){
          // 取消全选 数组为空
      if(selection && selection.length === 0){
          //  若取消全选，删除保存在selectedIds里和当前table数据的id一致的数据，达到，当前页取消全选的效果
          // 当前页的table数据
          this.importAll=false;
          this.selectedIds.clear();
          // var data = this.$refs.selection.data;
          // data.forEach((item)=>{
          //     if(this.selectedIds.has(item.id)){
          //         this.selectedIds.delete(item.id);
          //     }
          // })
      }else{
        // 由全部改为当前页
        this.importAll=true;
        this.selectedIds.clear();
        console.log(selection)
        this.resultIds = selection.map(item=>item.id)
        this.resultIds.forEach((item)=>{
            this.selectedIds.add(item);
        })
      }
      this.selectedSum = this.selectedIds.size;
  }

  public handleSelect(slection,row){
      this.selectedIds.add(row.id);
      this.selectedSum ++;
  }

  public handleCancel(sleection,row){
      this.selectedIds.delete(row.id);
      this.selectedSum --;
  }

  public setChecked() {
      if(!this.$refs.selection || !(this.$refs.selection as any).data ){
          return null;
      }
      // let objData = this.$refs.selection.data;
      let objData = this.dataList;//当前页数据
      // if(this.importAll){//选中所有页面
      //     // this.$refs.selection.selectAll(true);
      //     for (let index in objData) {
      //         objData[index]._checked = true
      //     }
      // }else{//没有全部选中所有页面
      //     for (let index in objData) {
      //         if (this.selectedIds.has(objData[index].id)) {
      //             objData[index]._checked = true
      //             console.log(index);
      //         }
      //     }
      // }
      for (let index in objData) {
          if (this.selectedIds.has((objData[index] as any).id)) {
              (objData[index] as any)._checked = true
          }
      }
    }

  public handlerDownloadCsv(){
    if(this.selectedIds.size == 0){
      this.$Message.error("请选择要审核的数据");
      return;
    }

    this.$Modal.confirm({
      title: '下载',
      content: '您确定要下载这些记录吗？',
      onOk: () => {
        this.handlerDownload();
      },
    });

  }

  public async handlerDownload(){
    if(this.importAll){//全选走邮件
      this.partnerEmail=true;
    }else{//当前页面直接下载
      let reqData: any = {
            list: JSON.stringify(this.inspectSelection),
            mid:(this.task as any).id
      }
      console.log(reqData)
      const res: any = await partnerBatchDownload(reqData);
      if (res.code === '200') {
        window.open(res.result, '_blank');
      } else {
        this.$Notice.warning({ desc: res.message });
      }
    }

  }

  public handlerUpCsv(){
    this.partnerShow=true;
  }

  private handleCancelPartner(){
    this.partnerShow=false;
  }

  private handleCancelEmail(){
    this.partnerEmail=false;
  }

  private async handleValidate() {
    if(!this.partnerCSVUrl){
      alert('请上传csv');
      return
    }
    const task = this.task as any;
    const resp :any= await partnerBatchCheck({
      mid: task.id,
      partnerCSVUrl: this.partnerCSVUrl,
    });
    console.log(resp)
    if(resp.code == 200){
      this.$Message.success('提交成功');
      this.partnerCSVUrl='';
      this.partnerShow=false;
    }else{
      this.$Notice.warning({ desc: resp.message });
    }
  }

  private handleValidateEmail(){
    this.$Modal.confirm({
      title: '下载',
      content: '请检查邮箱地址是否正确？【'+(this.formData as any).email+'】',
      onOk: () => {
        (this.$refs.formEmail as any).validate(valid => {
          if (valid) {
            var listIds = []
            this.selectedIds.forEach((item)=>{
                  listIds.push(item);
            })
            let reqData: any = {
                list: listIds,
                mid:(this.task as any).id,
                email:(this.formData as any).email
            }
            this.handleSubmitEamil(reqData)
          } else {
              return false;
          }
        });
      },
    });


  }

  private async handleSubmitEamil(reqData){
    const resp :any= await partnerDownloadAll(reqData);
    if(resp.code == 200){
      this.$Message.success('提交成功,请十分钟后检查邮件');
    }else{
      this.$Notice.warning({ desc: resp.message });
    }
    this.partnerEmail=false;
  }

  private async upLoad(e){
    const task = this.task as any;
    let times = new Date().getTime();
    let file = e.target.files[0];
    if(!file) return ;
    let extension = file.name.split('.')[1];
    let key = `${task.id}/${times}.${extension}`;

    uploadOss(file, key).then(res => {
      alert('上传完成');
      this.percent = 101;
      this.partnerCSVUrl = res;
      console.log(this.partnerCSVUrl)
    }).catch(err => {
      console.log(err)
      alert('上传失败');
    })
  }

  // private async upLoad(e){
  //   let resp: any;
  //   resp = await getQiniuToken();
  //   const task = this.task as any;
  //   let times = new Date().getTime();

  //   let file = e.target.files[0];
  //   if(!file) return ;
  //   let extension = file.name.split('.')[1];
  //   let key = `${task.id}/${times}.${extension}`;
  //   let config = {
  //               useCdnDomain: true,
  //               region: null,
  //           };
  //   let putExtra = {
  //       fname: "",
  //       params: {},
  //       mimeType: null,
  //       domain: 'https://static.cdn.longmaosoft.com'
  //   };
  //   let observer = {
  //       next: (res) => {
  //           this.percent = Math.floor(res.total.percent)
  //       },
  //       error(err){
  //           alert('上传失败');
  //       },
  //       complete: (res) => {
  //           alert('上传完成');
  //           this.percent = 101;
  //           this.partnerCSVUrl=`https://static.cdn.longmaosoft.com/${res.key}`;
  //           console.log(this.partnerCSVUrl)
  //       }
  //   };
  //   let observable = qiniu.upload(file, key, resp, putExtra, config)
  //   let subscription = observable.subscribe(observer);
  // }

  private async getList() {
    const task: any = this.task;
    let params: any = Object.assign({},this.searchParams);
    if ((this.searchParams as any).audit_status == '-1') {
      params.audit_status = null;
    }
    params.mid = task.id;
    params.puid=this.$route.params.puid
    if(this.$route.params.pkg_id && this.$route.params.pkg_id !='0'){
      params.pkg_id =this.$route.params.pkg_id
    }
    try {
      const data = (await newCheck(params)) as any;
      const resp :any =(await newCheckId(params));
      this.resultIds=resp;

      this.$nextTick(() => {
        this.dataList = data.rows;
        if(this.total != data.total){
          this.importAll=false;
          this.selectedIds.clear();
          this.selectedSum = this.selectedIds.size;
        }
        this.total = data.total;
        this.setChecked()
      });
    } catch (error) {
      console.log(error);
    }
  }
  // 查看详情
  private handleShow(id,auditStatus){
    const task: any = this.task;
    let from = task.from;

    if (from.indexOf('sketch') > -1) {
      from = from.indexOf('-') > -1 ? from.split('-')[1] : 'markPage';
    }
    let url = `${DOMAIN}/tools/${from}.html?type=56&qid=${id}&inspectmid=${task.id}`
    //JiDU 兼容jiduNlpPage
    if(from === 'jiduNlpPage'){
      url = `${JIDU_DOMAIN}/nlp?type=56&qid=${id}&inspectmid=${task.id}`
    }
    if(auditStatus == 7 || auditStatus ==8){
      url+=`&auditStatus=${auditStatus}`
    }

    const puid = (this.searchParams as any).puid
      if(puid){
        url+=`&s_au_id=${puid}`
      }
      const pteamid = (this.searchParams as any).pteamid
      if(pteamid){
        url += '&s_team_id=pteamid'
    }
    window.open(url);
  }
  private handlePreview(lid){
    const task: any = this.task;
    let from = task.from;
    let url = `${DOMAIN}/tools/${from}.html?type=311&validate=1&lid=${lid}&version=3&projectid=${task.projectid}&pre=benchmark`
    window.open(url);
  }
  // 审核
  private handlecheck(id) {
      const task: any = this.task;
      let from = task.from;
      if (from.indexOf('sketch') > -1) {
        from = from.indexOf('-') > -1 ? from.split('-')[1] : 'markPage';
      }
      let url = `${DOMAIN}/tools/${from}.html?type=55&id=${(this.task as any).id}&mlid=${id}&version=2`
      
      //JiDu 兼容jiduNlpPage
      if(from === 'jiduNlpPage'){
        url = `${JIDU_DOMAIN}/nlp?type=55&id=${(this.task as any).id}&mlid=${id}&version=2`
      }
      const puid = this.$route.params.puid
      if(puid){
        url+=`&s_au_id=${puid}`
      }
      const pteamid = (this.searchParams as any).pteamid
      if(pteamid){
        url += `&s_team_id=${pteamid}`
      }
      if(this.$route.params.pkg_id && this.$route.params.pkg_id !='0'){
        url += '&pkg_id='+this.$route.params.pkg_id
      }
      window.open(url);
  }
  // 搜索
  private handleSearch() {
    this.searchParams = Object.assign(this.searchParams, {
      page: '1',
    });
    (this.$refs['pages'] as any).currentPage = 1;
    this.getList();
  }
  // 分页
  private changePage(data) {
    this.searchParams = Object.assign(this.searchParams, {
      page: data,
    });
    this.getList();
  }

  // 重置
  private handleReset() {
    this.searchParams = {
      lid: '',
      puid: '',
      pteamid: '',
      audit_status: null,
      page: '1',
      pagesize: '20',
    };
    (this.$refs['pages'] as any).currentPage = 1;
    this.getList();
  }

  // 批量打回重做
  private handleRedo(){
    this.$Modal.confirm({
      title: '打回重做',
      content: '您确定要通过这些记录吗？',
      onOk: () => {
        this.postCheckOperation(9)
      },
    });
  }

  // 批量不通过
  private handleNoPass(){
    this.$Modal.confirm({
      title: '不通过',
      content: '您确定要通过这些记录吗？',
      onOk: () => {
        this.postCheckOperation(8)
      },
    });
  }

  private async postCheckOperation(type){
    let mlids = []
    this.selectedIds.forEach((item)=>{
      mlids.push(item);
    })
    const data = {
      mid: (this.task as any).id,
      type,
      mlids
    }
    const response:any = await newCheckOperation(data)
    if(response.code == 200){
      this.selectedIds.clear()
      this.$Message.success('操作成功');
      this.handleReset()
    }
  }
}
